var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCircleTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71875 13.5C1.71875 7.2868 6.75555 2.25 12.9688 2.25C19.182 2.25 24.2188 7.2868 24.2188 13.5C24.2188 19.7132 19.182 24.75 12.9688 24.75C6.75555 24.75 1.71875 19.7132 1.71875 13.5ZM12.9688 0.75C5.92712 0.75 0.21875 6.45837 0.21875 13.5C0.21875 20.5416 5.92712 26.25 12.9688 26.25C20.0104 26.25 25.7188 20.5416 25.7188 13.5C25.7188 6.45837 20.0104 0.75 12.9688 0.75ZM12.9688 7.75C12.5545 7.75 12.2188 8.08579 12.2188 8.5V8.51C12.2188 8.92421 12.5545 9.26 12.9688 9.26H12.9787C13.393 9.26 13.7287 8.92421 13.7287 8.51V8.5C13.7287 8.08579 13.393 7.75 12.9787 7.75H12.9688ZM12.3595 13.1432C12.5505 13.0476 12.7656 13.2202 12.7138 13.4274L11.7685 17.2088C11.4058 18.6593 12.9116 19.8671 14.2489 19.1985L14.3042 19.1708C14.6747 18.9856 14.8248 18.5351 14.6396 18.1646C14.4543 17.7941 14.0038 17.6439 13.6333 17.8292L13.578 17.8568C13.387 17.9524 13.1719 17.7798 13.2237 17.5726L14.169 13.7912C14.5317 12.3407 13.0259 11.1329 11.6887 11.8015L11.6333 11.8292C11.2629 12.0144 11.1127 12.4649 11.2979 12.8354C11.4832 13.2059 11.9337 13.3561 12.3042 13.1708L12.3595 13.1432Z",
    fill: "#60636B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircleTransparent);
export default __webpack_public_path__ + "static/media/information-circle-transparent.99367049c8e32702f7fc3119931bdb2e.svg";
export { ForwardRef as ReactComponent };